import React, { useEffect } from 'react'
import ReactPixel from 'react-facebook-pixel'
import Landscape from './Landscape'
import Offers from './Offers'
import MakerVsWatcher from './MakerVsWatcher'
import Footer from './Footer'
import Testimony from './Testimony'
import QuestionsAnswersViewer from '../../components/QuestionsAnswersViewer'

const Home = () => {
  useEffect(() => {
    ReactPixel.pageView()
  }, [])

  return (
    <div>
      <Landscape />
      <MakerVsWatcher />
      <Offers />
      <QuestionsAnswersViewer from="home" />
      <Testimony />
      <Footer />
    </div>
  )
}

export default Home
